// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OccViewer } from "../viewer/viewer.js";
/**
 * Update [[RenderingParams]] in OccViewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    let aRenderingParams = theModule.renderingParams;
    aRenderingParams.setBackgroundCubemap = function (theImagePath, theLightmapOnly, theToUpdate) {
        return __awaiter(this, void 0, void 0, function* () {
            const aFilePath = "/emulated/cubemap.jpg";
            yield theModule.modelLoader.uploadUrl(theImagePath, aFilePath, true);
            //@ts-ignore
            this._cppSetBackgroundCubemap(aFilePath, theLightmapOnly, theToUpdate);
        });
    };
});
